/** TTL condiviso per cache React Query + persist IDB (sessioni workspace spettrale / gruppi). */
export const RESEARCH_QUERY_CACHE_TTL_MS = 24 * 60 * 60 * 1000;
